import React from "react";
import { FormattedMessage } from "react-intl";
import { Table } from "semantic-ui-react";

const ListHeader = () => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>
          <FormattedMessage id={"cart.tableTitle.pattern"} />{" "}
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id={"cart.tableTitle.name"} />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id={"cart.tableTitle.size"} />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id={"cart.tableTitle.price"} />
        </Table.HeaderCell>
        <Table.HeaderCell></Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
};

export default ListHeader;
